import { Options } from '@angular-slider/ngx-slider';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { AllProductDataSource } from 'src/infrastructure/dataSource/AllProductDataSource';
import { AllProductDataSourceInTwo } from 'src/infrastructure/dataSource/AllProductDataSourceInTwo';
import { CategoryTypes } from 'src/infrastructure/enums/categoryTypes';
import { Colors } from 'src/infrastructure/enums/colors';
import { ItemType } from 'src/infrastructure/enums/itemTypeEnum';
import { ProductViews } from 'src/infrastructure/enums/productViews';
import { CoreLabels } from 'src/infrastructure/labels/coreLabels';
import { Category } from 'src/models/DTO/categeroies/category';
import { AvailableFilters } from 'src/models/DTO/filters/availableFilters';
import { ProductSearchFilter } from 'src/models/DTO/filters/productSearchFilter';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { HomeItemDetails } from 'src/models/DTO/items/homeItem';
import { Item } from 'src/models/DTO/items/item';
import { ItemTypeConfig } from 'src/models/DTO/items/itemTypeConfig';
import { ItemsPerCategory } from 'src/models/DTO/items/itemsPerCategory';
import { ProductCollection } from 'src/models/DTO/products/productCollection';
import { ProductCollectionItem } from 'src/models/DTO/products/productCollectionItem';
import { UserDTO } from 'src/models/DTO/user/user';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { UserService } from 'src/services/core/user/user.service';
import { CategoriesService } from 'src/services/request/categories/categories.service';
import { FiltersService } from 'src/services/request/filters/filters.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { ProductsService } from 'src/services/request/products/products.service';
import { RatingsService } from 'src/services/request/ratings/ratings.service';
import { SearchService } from 'src/services/request/search/search.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

declare var bootstrap: any;

@Component({
  selector: 'app-categoryproducts',
  templateUrl: './categoryproducts.component.html',
  styleUrls: ['./categoryproducts.component.css']
})
export class CategoryproductsComponent extends HistoryBaseComponent implements OnInit {


  @ViewChild('search')
  searchElement!: ElementRef;

  @ViewChild('voucher')
  voucher!: any;

  @ViewChild('categories')
  categories!: any;

  @ViewChild('order')
  order!: any;

  @ViewChild('voucherInit')
  voucherInit!: any;

  @ViewChild(CdkVirtualScrollViewport)
  virtualScroll!: CdkVirtualScrollViewport;

  maxOptionsPerFilter = Config.maxNumberOfFilterOptions;
  isSearchEnabled = false;
  group?: boolean = undefined;
  delivery?: boolean  = undefined;
  category = '';
  shouldFiltersBevisible = true;
  minValue: number = 0;
  maxValue: number = 200;
  options: Options = {};

  private _availableFilters: AvailableFilters = {};
  private _routes: { [key: string] : any }  = {
    categories: ['categories'],
    fav: ['product/favourites'],
    myorders: ['orders'],
    returns: ['returns']
  }
  private _sorters: { [key: string] : any } = {
    new: 'Най-нови',
    rate: 'Най-популярни',
    price: 'Най-ниска цена',
    maxprice: 'Най-висока цена'
  }
  private firstOptionsCache = new Map<string, any[]>();
  private _previousUrl: string = '';
  private _brands: string[] = [];
  private _partners: string[] = [];
  private _options: any = {};
  private _title: string = '';
  private _categoryAsText: string = '';
  private _sorter: string = 'newest';
  private _categoryUUID: string = '';
  private _viewType = ProductViews.grid
  private _rootCategory: string = ''
  private _shouldShowSearchIcon = true;
  private _ds?: AllProductDataSource;
  private _ds2?: AllProductDataSourceInTwo;
  private _allRootCategories: Category = {data: []};
  private _filterCategories: Category = {data: []};
  private _productImages: ImageCollection = {data: []};
  private _products: ProductCollection = {data: [], meta: { last_page: -1 }};
  private _page = 1;
  private _items: Item[] = [];
  private _homeItemsDetails: HomeItemDetails[] = [];
  private _searchedText?: string = undefined;
  private _productRootCategories: Category[] = [];
  private _serviceRootCategories: Category[] = [];
  private _itemsPerCategory: ItemsPerCategory[] = [];
  private _filteredItemsPerCategory: ItemsPerCategory[] = [];
  private _itemTypeSelected: ItemType | null = null;
  private _itemTypeConfigs: ItemTypeConfig[] = [
    {
      type: ItemType.Product,
      query: Config.productType,
      label: Config.productLabel,
      itemsKey: Config.productKey,
    },
    {
      type: ItemType.Service,
      query: Config.serviceType,
      label: Config.serviceLabel,
      itemsKey: Config.serviceKey,
    }
  ];
  private _expandedSections: any = {};
  private _selectedItemConfig: ItemTypeConfig = {} as any;
  private _loggedUser?: UserDTO;
  private _filter: ProductSearchFilter = { filters: [ { key: 'categories', value: this._categoryUUID }] };
  private _defaultFilter: ProductSearchFilter = { filters: [ { key: 'categories', value: this._categoryUUID }] };

  selectedOrder = this._sorters.new;

  constructor(
    private localStorageService: LocalstorageService,
    private activatedRoute: ActivatedRoute,
    private search: SearchService,
    private categoriesService: CategoriesService,
    private imageService: ImagesService,
    private productsService: ProductsService,
    private router: Router,
    private modalService: NgbModal,
    private userStateService: LoggedUserService,
    private userService: UserService,
    private ratingService: RatingsService,
    private cd: ChangeDetectorRef,
    private filtersService: FiltersService,
    protected location: Location,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this._previousUrl = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString() || '';
    this._pageTitle = 'categoryproducts';
    this.getCategories();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this._title = decodeURIComponent(decodeURIComponent(params.title));
      this._categoryAsText = decodeURIComponent(decodeURIComponent(params.title));
      if (params.type == CategoryTypes.root) {
        this._filter = { filters: [ { key: 'categories', value: params.id }] };
        this._defaultFilter = { filters: [ { key: 'categories', value: params.id }] };
        this.startInitialSearch();
      }
      else if (params.type == CategoryTypes.child) {
        this._categoryUUID = params.id;
        this.category = this._categoryUUID;
        this._filter = { filters: [ { key: 'childCategory', value: params.id }] };
        this._defaultFilter = { filters: [ { key: 'childCategory', value: params.id }] };
        this.filtersService.getAvailableFiltersForChildCategory(this._categoryUUID).subscribe(filters => {
          this._availableFilters = filters;
          this.setPrices()
          this.startInitialSearch();
        })
      }

    })
  }

  private startInitialSearch() {
    if (this._previousUrl.includes('/product/') && !this._previousUrl.includes('product/favourites')) {
      this.setUpFilters();
    }
    else {
      this.createSearch();
    }
  }

  private setUpFilters() {
    let filtersString = this.localStorageService.getLocalStorageItem('filters') || '';
    if (filtersString) {
      let filters = JSON.parse(filtersString);
      this.minValue = filters.price_from;
      this.maxValue = filters.price_to
      if (filters.delivery !== undefined) {
        this.delivery = filters.delivery;
      }
      if (filters.group !== undefined) {
        this.group = filters.group;
      }
      if (filters.brands && filters.brands.length) this._brands = filters.brands;
      if (filters.partners && filters.partners.length) this._partners = filters.partners;
      if (filters.options && Object.keys(filters.options).length) this._options = filters.options;
      this.filter();
      this.localStorageService.removeLocalStorageItem('filters');
    }

  }

  private saveCurrentFilters() {
    let filters: any = {};
    filters.price_from = this.minValue;
    filters.price_to = this.maxValue;
    if (this.delivery !== undefined) {
      filters.delivery = this.delivery;
    }
    if (this.group !== undefined) {
      filters.group = this.group;
    }
    if (this._brands.length) filters.brands = this._brands;
    if (this._partners.length) filters.partners = this._partners;
    if (Object.keys(this._options).length) filters.options = this._options;
    this.localStorageService.setLocalStorageItem('filters', JSON.stringify(filters));
  }

  private setPrices() {
     this.minValue = Math.floor(Number.parseFloat(this._availableFilters.data?.price_from || '0'))
     this.maxValue = Math.round(Number.parseFloat(this._availableFilters.data?.price_to || '0') + 10);
     this.options.floor = this.minValue;
     this.options.ceil = this.maxValue;
  }


  private getCategories() {
    this.categoriesService.getAllRootCategories().subscribe(categories => {
      this._allRootCategories = {
        data: []
      }
      categories.data.forEach(category => {
        this._allRootCategories.data.push(category);
      });
    })
  }

  get title() {
    return this._title;
  }


  private shouldShowInitialVoucherInit() {
    if (!this.isUserLogged && this.localStorageService.getLocalStorageItem(Config.shouldShowInitialVoucherInitKey) !== 'false') {
      // show modal
      this.modalService.open(this.voucherInit, { size: 'sm',  windowClass: 'loginModal' })
      this.localStorageService.setLocalStorageItem(Config.shouldShowInitialVoucherInitKey, 'false')
    }
  }


  private getImagesForProduct(product: ProductCollectionItem) {
    this.imageService.getImagesForProduct("PRODUCT", product.uuid).subscribe(image => {
      if (image.data.length) {
        let firstImage = image.data[0];
        firstImage.itemUUID = product.uuid;
        this._productImages.data.push(firstImage);
      }
    })
  }

  private getRatingsForProduct(product: ProductCollectionItem) {
    this.ratingService.getRatingsPerProduct(product.uuid).subscribe(ratings => {
        product.ratings = ratings;
        this.getRatingsAvg(product)
    })
  }

  private getRatingsAvg(product: ProductCollectionItem) {
    let ratingsScore = 0;
    const ratingsCount = product.ratings?.data.length || 0;
    product.ratings?.data.forEach(rating => {
      ratingsScore += rating.rating
    })
    product.ratingAvgValue = ratingsScore / ratingsCount;
  }


  private getSearchResults() {
    this.search.getSearchResults(Config.productPerPage, this._page, this._searchedText || '').subscribe(product => {
      this._products.meta.last_page = product.meta.last_page;
        product.data.forEach(product => {
          this.getImagesForProduct(product);
          this.getRatingsForProduct(product);
          this._products.data.push(product);
        });
    })
  }



  ngAfterViewInit(): void {
    this.shouldShowInitialVoucherInit();
    const lastSearchText = this.localStorageService.getLocalStorageItem(Config.lastSearchTextKey);
    if (lastSearchText) {
      this._searchedText = lastSearchText;
      this.createSearch();
    }
  }

  get themePallete() :ThemePalette {
    return 'primary'
  }

  get availableFilters() {
    return this._availableFilters;
  }

  get viewType() {
    return this._viewType;
  }

  get topCSS() {
    return (this._searchedText) ? 'background-color: #F5F7F8; height: 92vh; overflow-y: hidden; padding: 7px; overflow-x: hidden;' : 'background-color: #F5F7F8; height: 92vh; overflow-y: scroll; padding: 7px; overflow-x: hidden;';
  }

  get products() {
    return this._products;
  }

  get rootCategories() {
    return this._allRootCategories;
  }

  get filterCategories() {
    return this._filterCategories;
  }

  get items() {
    return this._items;
  }

  get searchedText() {
    return this._searchedText;
  }

  get shouldShowSearchIcon() {
    return this._shouldShowSearchIcon;
  }

  get allProductRootCategories() {
    return this._productRootCategories;
  }

  get allServiceRootCategories() {
    return this._serviceRootCategories;
  }

  get filteredItemsPerCategory() {
    return this._filteredItemsPerCategory;
  }

  get ds() {
    return this._ds;
  }

  get ds2() {
    return this._ds2;
  }

  get selectedFilterCategory() {
    if (!this.category) return '';
    if (this._categoryAsText) return this._categoryAsText;
    return this._filterCategories.data.find(category => category.uuid == this.category)?.name || '';
  }

  get viewTypeIcon() {
    return this._viewType == ProductViews.grid ? "/assets/images/home/icon-list-view.svg" : "/assets/images/home/icon-view.svg"
  }

  get productViewTypes() {
    return ProductViews
  }

  private set itemTypeSelected(value: ItemType) {
    this._itemTypeSelected = value;
    this._selectedItemConfig = this._itemTypeConfigs.filter((config) => config.type == value)[0];
  }

  get virtualSrollHeight() {
    let scrollHeight = 0
    if (this.viewType == ProductViews.grid) {
      scrollHeight = 2 * 275;
    }
    else if (this.viewType == ProductViews.list) {
      scrollHeight = 4 * 170;
    }
    return 'height: ' + scrollHeight + 'px;'
  }

  private createSearch() {
    this.productsService.getAllProductsPerSearch(1, 1, this._searchedText, this._sorter, this._filter).subscribe(result => {
      if (!result.data.length) return;
      this._ds = undefined;
      setTimeout(() => {
        this._ds = new AllProductDataSource(this.ratingService,this.productsService, this.imageService, result.meta.last_page, this._searchedText || '', this._sorter, this._filter, this.viewType == ProductViews.grid ? Config.defaultItemsPerPage * 2 : Config.defaultItemsPerPage)
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
      this._ds2 = undefined;
      setTimeout(() => {
        this._ds2 = new AllProductDataSourceInTwo(this.ratingService,this.productsService, this.imageService, result.meta.last_page, this._searchedText || '', this._sorter, this._filter, this.viewType == ProductViews.grid ? Config.defaultItemsPerPage * 2 : Config.defaultItemsPerPage)
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
    })
  }

  get isUserLogged() {
    return this.userService.isUserLogged();
  }

  get areAvailableFiltersSet() {
    return this._availableFilters.data;
  }

  get availableFilterBrands() {
    if (!this._availableFilters.data || !this._availableFilters.data.brands) return [];
    let brands : {
      key: string,
      value: any
    }[] = [];
    Object.keys(this._availableFilters.data.brands).forEach(brand => {
      brands.push( { key: brand, value: (this._availableFilters.data!.brands as any)[brand]})
    });
    return brands;
  }

  get availableFilterOptions() {
    if (!this._availableFilters.data || !this._availableFilters.data.options) return [];
    let options : {
      key: string,
      value: any
    }[] = [];
    Object.keys(this._availableFilters.data.options).forEach(option => {
      let optionsArray =  (this._availableFilters.data!.options as any)[option];
      if (option == "Цвят") {
        optionsArray.values.sort((a: { text: string; }, b: { text: any; }) => a.text.localeCompare(b.text))
      }
      if (option == "Пол" &&
      (this._availableFilters.data!.options as any)[option].values.findIndex((optionToFind: any) => optionToFind.text == 'Жени') > -1 &&
      (this._availableFilters.data!.options as any)[option].values.findIndex((optionToFind: any) => optionToFind.text == 'Унисекс') > -1) {
        var womanValue : any = optionsArray.values.splice(optionsArray.findIndex((optionToFind: any) => optionToFind.text == 'Жени'), 1)[0]
        optionsArray.values.push(womanValue)
        var unisexValue : any = optionsArray.values.splice(optionsArray.findIndex((optionToFind: any) => optionToFind.text == 'Унисекс'), 1)[0]
        optionsArray.values.push(unisexValue)
      }
      options.push( { key: option, value: (this._availableFilters.data!.options as any)[option]})
    });
    return options;
  }

  get availableFilterPartners() {
    if (!this._availableFilters.data || !this._availableFilters.data.partners) return [];
    let partners : {
      key: string,
      value: any
    }[] = [];
    Object.keys(this._availableFilters.data.partners).forEach(partner => {
      partners.push( { key: partner, value: (this._availableFilters.data!.partners as any)[partner]})
    });
    return partners;
  }

  get colors() {
    return Colors;
  }

  getColor(color: string) {
    return this.colors.find(colorEl => colorEl.name == color)?.color || '';
  }

  public getFirst(items: Array<any>) {
    return items.slice(0, this.maxOptionsPerFilter)
  }

  public getFirstOptions(items: any) {
    return items.values.slice(0, this.maxOptionsPerFilter)
  }

  public isAreaExpanded(area: string) {
    if (this._expandedSections[area]) return true;
    return false;
  }

  public setExpandedArea(area: string, isExpanded: boolean) {
    this._expandedSections[area] = isExpanded;
  }

  public brandUpdated(event: any) {
    let brand = event.target.value;
    if (this._brands.includes(brand)) {
      this._brands = this._brands.filter(brandToFilter => brandToFilter != brand);
    }
    else this._brands.push(brand);
  }

  public shouldBrandBeChecked(brand: string) {
    return this._brands.includes(brand);
  }

  public partnerUpdated(event: any) {
    let partner = event.target.value;
    if (this._partners.includes(partner)) {
      this._partners = this._partners.filter(partnerToFilter => partnerToFilter != partner);
    }
    else this._partners.push(partner);
  }

  public shouldPartnerBeChecked(partner: string) {
    return this._partners.includes(partner);
  }


  public optionUpdated(value: any, option: string, inputType: string) {
    if (inputType === 'radio') {
      if (value === 'all') {
        delete this._options[option];
      } else {
        this._options[option] = [value];
      }

      return;
    }

    const selectedValues = this._options[option] || [];

    if (selectedValues.includes(value)) {
      const updatedValues = selectedValues.filter((optionToFilter: any) => optionToFilter !== value);

      if (updatedValues.length) {
        this._options[option] = updatedValues;
      } else {
        delete this._options[option];
      }

      return;
    }

    this._options[option] = [...selectedValues, value];
  }

  public shouldOptionBeChecked(value: any, option: string) {
    if (value === 'all') {
      return !Object.keys(this._options).includes(option)
    }
    return this._options[option] && this._options[option].includes(value);
  }

  public toggleViewType() {
    if (this._viewType == ProductViews.grid) {
      this._viewType = ProductViews.list
    }
    else if (this._viewType == ProductViews.list) {
      this._viewType = ProductViews.grid
    }
  }

  public main() {
    this.localStorageService.setLocalStorageItem(Config.lastSearchTextKey, '');
    this.router.navigate(['bottomtabs/home'])
  }

  public selectCategory(uuid: string, modal: any) {
    if (this._allRootCategories.data.find(category => category.uuid == uuid) ||
        Config.technicalCategories.find(tmpUuid => tmpUuid == uuid)) {
          this.getSubcategories(uuid)
        }
    else {
      this.category = uuid;
      this._categoryAsText = '';
      if (this.category) {
        this.filtersService.getAvailableFiltersForChildCategory(this.category).subscribe(filters => {
          this._availableFilters = filters;
          this.clear(false);
          this._filter = { filters: [ { key: 'childCategory', value: this.category }] };
          this._defaultFilter = { filters: [ { key: 'childCategory', value: this.category }] };
          const url = '/bottomtabs/categories/sub/products/' + this.category + '/' + this.selectedFilterCategory + '/' + CategoryTypes.child;
          this.localStorageService.setLocalStorageItem(Config.lsCatFromMain, url)
          this.router.navigate([url]);
        })
      }
      else {
        this._availableFilters = {};
        this.clear(false);
      }
      modal.close();
    }
  }

  public openCategories(categories: any) {
    this._filterCategories.data = [...this._allRootCategories.data];
    this.modalService.open(categories, { size: 'sm',  windowClass: 'loginModal categories' })
  }

  public close(modal: any) {
    modal.close();
  }


  public open(modal: any) {
    this.modalService.open(modal, { size: 'sm',  windowClass: 'loginModal' })
  }

  public getProductsPerCategory(categoryUUID: string) : Array<ProductCollectionItem> {
    return this._products.data.filter(item => item.category.parentCategoryUUID == categoryUUID);
  }

  getProductCardBasePrice(product: ProductCollectionItem): number {
    const pricing = product?.pricing || [];
    if (!pricing.length) {
      return 0;
    }

    const singleQtyPricing =
      pricing.find((price) => Number(price.quantity_from) === 1) || pricing[0];

    return Number(singleQtyPricing?.price_per_piece) || 0;
  }

  hasProductPrice(product: ProductCollectionItem): boolean {
    return this.getProductCardBasePrice(product) > 0;
  }

  // public getPriceRange(product: ProductCollectionItem) {
  //   const pricingCounts = product.pricing.length;
  //   if (!pricingCounts) return [];
  //   let pricing = product.pricing.find(pricing => pricing.quantity_from == 1);
  //   // return product.pricing[pricingCounts - 1].price_per_piece + CoreLabels.currency[this._language] + '-' +
  //   // product.pricing[0].price_per_piece + CoreLabels.currency[this._language]
  //   let priceArray = pricing?.price_per_piece.split('.') || [];
  //   priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   priceArray.push(CoreLabels.currency[this._language]);
  //   return priceArray;
  // }

  public productImage(productUUID: string) {
    const imageURL = this._productImages.data.find(image => image.itemUUID == productUUID)?.original.url;
    return (imageURL) ? imageURL : null;
  }

  public clear(force: boolean = false) {
    this._brands= [];
    this._partners= [];
    this._options = {};
    this.group = undefined;
    this.delivery = undefined;
    if (force) {
      this.category = '';
    }
    this.options = {};
    this.setPrices()
    this._filter.filters = [...this._defaultFilter.filters]
    this.productsService.getAllProductsPerSearch(1, 1, this._searchedText, this._sorter, this._filter).subscribe(result => {
      this._ds = undefined;
      setTimeout(() => {
        this._ds = new AllProductDataSource(this.ratingService,this.productsService, this.imageService, result.meta.last_page, this._searchedText || '', this._sorter, this._filter, this.viewType == ProductViews.grid ? Config.defaultItemsPerPage * 2 : Config.defaultItemsPerPage)
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
      this._ds2 = undefined;
      setTimeout(() => {
        this._ds2 = new AllProductDataSourceInTwo(this.ratingService,this.productsService, this.imageService, result.meta.last_page, this._searchedText || '', this._sorter, this._filter, this.viewType == ProductViews.grid ? Config.defaultItemsPerPage * 2 : Config.defaultItemsPerPage)
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
    })
  }

  private prepareFilters() {
    this._filter.filters =  [...this._defaultFilter.filters];
    let declaredFilters = { filters: new Array<any>()};
    if (this.category) {
      declaredFilters.filters.push(
      { key: 'price_from', value: this.minValue },
      { key: 'price_to', value: this.maxValue })
    }
    if (this.delivery !== undefined) {
      declaredFilters.filters.push({ key: 'free_delivery', value: this.delivery as any })
    }
    if (this.group !== undefined) {
      declaredFilters.filters.push({ key: 'group', value: this.group as any })
    }
    if (this._brands.length) declaredFilters.filters.push({ key: 'brands', value: this._brands as any })
    if (this._partners.length) declaredFilters.filters.push({ key: 'partner', value: this._partners as any })
    if (Object.keys(this._options).length) declaredFilters.filters.push({ key: 'options', value: this._options as any })

    this._filter.filters.push(...declaredFilters.filters);
  }

  public filter() {
    this.prepareFilters();
    this.productsService.getAllProductsPerSearch(1, 1, this._searchedText, this._sorter, this._filter).subscribe(result => {
      this._ds = undefined;
      setTimeout(() => {
        this._ds = new AllProductDataSource(this.ratingService,this.productsService, this.imageService, result.meta.last_page, this._searchedText || '', this._sorter, this._filter, this.viewType == ProductViews.grid ? Config.defaultItemsPerPage * 2 : Config.defaultItemsPerPage)
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
      this._ds2 = undefined;
      setTimeout(() => {
        this._ds2 = new AllProductDataSourceInTwo(this.ratingService,this.productsService, this.imageService, result.meta.last_page, this._searchedText || '', this._sorter, this._filter, this.viewType == ProductViews.grid ? Config.defaultItemsPerPage * 2 : Config.defaultItemsPerPage)
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
      this.closeOffcanvas();
    })
  }

  closeOffcanvas() {
    var myOffcanvas = document.getElementById('staticBackdrop')
    var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
    bsOffcanvas.hide()
  }

  public getSubcategories(rootCategory: string) {
    this._rootCategory = rootCategory;
    const depth = Config.technicalCategories.find(tmpUUID => tmpUUID == rootCategory) ? 2 : 1;
    this.categoriesService.getSubcategories(rootCategory, depth).subscribe(categories => {
      this._filterCategories = categories;
      this._filterCategories!.data.push(this._filterCategories!.data.splice(this._filterCategories!.data.findIndex(category => category.name == 'Други'), 1)[0]);
    })

  }

  goToCategory(id: string, title: String) {
    this.router.navigate(['bottomtabs/categories/sub/products/' + id + '/' + title])
  }

  sortSelectionChange(event: any) {
    console.log(event.target.value)
  }

  imageFromItem(itemId: string) : string {
    return '';
  }

  initialSearch(event: any) {
    this.onSearchTextChange(event);
    this.initiateSearch();
  }

  onSearchTextChange(event: any) {
    this._searchedText = event.target.value;
  }

  initiateSearch() {
    if (this._searchedText && this._searchedText.length < 3) {
      return;
    }
    if (this._searchedText && this._searchedText.length >= 3) {
      this.localStorageService.setLocalStorageItem(Config.lastSearchTextKey, this._searchedText);
      this.createSearch();
    }
  }

  onOptionsTap(route: string, loginModal: any) {
    if (!this.isUserLogged && !route.includes('categories')) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' })
      return;
    }
    this.router.navigate(this._routes[route]);
  }

  openItem(productUUID: string, categoryUUID: string) {
    this.saveCurrentFilters();
    this.router.navigate(['product/' + productUUID.toString() + '/' + categoryUUID]);
  }

  clearSeacrhedText() {
    this._searchedText = '';
    this.localStorageService.removeLocalStorageItem(Config.lastSearchTextKey);
  }

  loadMoreItems() {
    if (this._page < this._products.meta.last_page) {
      this._page++;
    }
    this.getSearchResults();
  }

  selectOrder(sorterType: string, sortName: string, modal: any) {
    this._sorter = sorterType;
    this.selectedOrder = this._sorters[sortName];
    modal.close();
    this.createSearch();
    this.virtualScroll.setRenderedRange({start: 0, end: 20})
  }

  registration(currentModal: any) {
    currentModal.close();
    this.router.navigate(['registration']);
  }

  loginNavigation(currentModal: any) {
    currentModal.close();
    this.router.navigate(['login']);
  }

  back() {
    this.localStorageService.removeLocalStorageItem(Config.lsCatFromMain);
    super.back();
  }

}
